import { createSlice } from '@reduxjs/toolkit'

import { fetchToken } from './actions/fetch_customer_cert_capture_token'

const initialState = {
  token: '',
  tokenError: null,
  loading: false,
}

const certCaptureTokenSlice = createSlice({
  name: 'certCaptureToken',
  initialState,
  reducers: {
    resetTokenError: (state) => {
      state.loading = false
      state.tokenError = null
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchToken.pending, (state) => {
      state.loading = true
    })
    builder.addCase(fetchToken.fulfilled, (state, action) => {
      state.loading = false
      state.token = action.payload
    })
    builder.addCase(fetchToken.rejected, (state, action) => {
      state.loading = false
      state.tokenError = action.payload
    })
  }
})

export const {
  reducer,
  actions: {
    resetTokenError,
  }
} = certCaptureTokenSlice
